module.exports = __webpack_public_path__ + "img/baac.df920259.svg";